// extracted by mini-css-extract-plugin
export default {"container":"r9enV","titleRow":"B1PCJ","title":"EkeDl","viewItems":"C4qBq","spreadRow":"_36T9o","total":"_6W0oG"};